import { render, staticRenderFns } from "./RateListsLayout.vue?vue&type=template&id=e1ec6a64&"
import script from "./RateListsLayout.vue?vue&type=script&lang=js&"
export * from "./RateListsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports